export const WAITLIST_LOAD = 'waitlist/LOAD';

export const WAITLIST_LOCK = 'waitlist/LOCK';
export const WAITLIST_CLEAR = 'waitlist/CLEAR';

export const WAITLIST_UPDATE = 'waitlist/UPDATE';
export const WAITLIST_JOIN = 'waitlist/JOIN';
export const WAITLIST_LEAVE = 'waitlist/LEAVE';
export const WAITLIST_MOVE = 'waitlist/MOVE';

export const DO_JOIN_START = 'waitlist/DO_JOIN_START';
export const DO_JOIN_COMPLETE = 'waitlist/DO_JOIN_COMPLETE';

export const DO_LEAVE_START = 'waitlist/DO_LEAVE_START';
export const DO_LEAVE_COMPLETE = 'waitlist/DO_LEAVE_COMPLETE';

export const DO_LOCK_START = 'waitlist/DO_LOCK_START';
export const DO_LOCK_COMPLETE = 'waitlist/DO_LOCK_COMPLETE';

export const DO_CLEAR_START = 'waitlist/DO_CLEAR_START';
export const DO_CLEAR_COMPLETE = 'waitlist/DO_CLEAR_COMPLETE';
